/* eslint-disable no-magic-numbers */
const PRIORITIZED_PAYMENT_METHODS = ['paypal', 'mercado_pago', 'coupon'];

export default function getProjectsWithPictures(projects) {
  Object.keys(projects).forEach(id => {
    const project = projects[id];
    let mainPicture;
    if (project.projectPictures && project.projectPictures.length > 0) {
      mainPicture = project.projectPictures.find(picture => picture.pictureType === 'principal');

      if (mainPicture) {
        project.projectPictures = project.projectPictures.filter(
          picture => picture.pictureType !== 'principal'
        );
      } else {
        mainPicture = project.projectPictures[0];
        project.projectPictures.shift();
      }
    }

    project.mainPicture = mainPicture;

    projects[id] = project;
  });

  return projects;
}

export function parseProjectPaymentMethods(project) {
  if (!(project && project.paymentMethods)) return false;

  const methods = {};

  project.paymentMethods.split(',').forEach((method) => {
    methods[method] = true;
  });

  return methods;
}

export function getInitialPaymentMethod(paymentMethods) {
  const initialPaymentMode = PRIORITIZED_PAYMENT_METHODS.find(mode => paymentMethods[mode]);

  return initialPaymentMode === 'mercado_pago' ? 'mercadopago' : initialPaymentMode;
}

export function isPaymentModeActive(paymentMethods, paymentMode) {
  const parsedPaymentMode = paymentMode === 'mercadopago' ? 'mercado_pago' : paymentMode;

  return paymentMethods[parsedPaymentMode];
}

export function getCheckoutUrl({ token, paymentMode, zoom = 22 }) {
  return `/purchases/${token}/checkout/?zoom=${zoom}&payment_type=${paymentMode}`;
}
